"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL = void 0;
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _constants = require("../constants");
var _createWorkflowAppolloClient = _interopRequireDefault(require("../utils/createWorkflowAppolloClient"));
var _utils = require("cornerstone_ui_core/lib/utils");
var _lodash = require("lodash");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL = exports.GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/apollo_gateway" + _constants.servicegraphql : _constants.servicebasepath + "/apollo_gateway" + _constants.servicegraphql;
const client = (0, _createWorkflowAppolloClient.default)(GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL, {
  appName: "UMU"
});
const GET_APP_TIMEOUT = (0, _graphqlTag.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getAppTimeOut($type1: String) {\n    getAppTimeOut(appShortKey: $type1) {\n      timeout\n    }\n  }\n"])));
class TimeoutService {
  static getAppTimeout(appShortKey) {
    return client.query({
      query: GET_APP_TIMEOUT,
      variables: {
        type1: appShortKey
      }
    }).then(res => (0, _lodash.cloneDeep)(res)).catch(_utils.errorHandler);
  }
}
var _default = exports.default = TimeoutService;